import { Component, StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  componentDidCatch(error: Error, info: { componentStack?: string }) {
    console.error("Render error:", error, info);
  }
  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div style={{ padding: 16, fontFamily: "ui-monospace, monospace", fontSize: 12, whiteSpace: "pre-wrap" }}>
        <h2 style={{ fontSize: 14, marginBottom: 8 }}>Something broke while rendering</h2>
        <div style={{ color: "#c00", marginBottom: 8 }}>{error.message}</div>
        <pre style={{ overflow: "auto" }}>{error.stack}</pre>
        <button
          onClick={() => location.reload()}
          style={{ marginTop: 12, padding: "6px 10px", border: "1px solid #888", borderRadius: 4 }}
        >
          Reload
        </button>
      </div>
    );
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => console.error("window.error:", e.error ?? e.message));
  window.addEventListener("unhandledrejection", (e) => console.error("unhandledrejection:", e.reason));
}

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
